import React, { useEffect, useContext } from 'react';
import Logo from '../../images/logo.png';
import SearchBox from './search-box';
import Phone from '../../images/cellphone.svg';
import Laptop from '../../images/laptop.svg';
import Television from '../../images/television.svg';
import WashingMachine from '../../images/washing-machine.svg';
import AC from '../../images/hvac.svg';
import Refrigerator from '../../images/fridge.svg';
import Tablet from '../../images/tablet.svg';

import './style2.css';

import url from '../../url';
import { ApplicationContext } from '../application-context/application-context';
import { Link } from 'react-router-dom';

const Navbar2 = ({ loggedIn }) => {
  const languageContext = useContext(ApplicationContext);
  useEffect(() => {
    const $ = window.$;
    $(document).ready(function () {
      // executes when HTML-Document is loaded and DOM is ready

      // breakpoint and up
      $(window).resize(function () {
        if ($(window).width() >= 980) {
          // when you hover a toggle show its dropdown menu
          $('.header-menu-mega .navbar .dropdown-toggle').hover(function () {
            $(this).parent().toggleClass('show');
            $(this).parent().find('.dropdown-menu').toggleClass('show');
          });

          // hide the menu when the mouse leaves the dropdown
          $('.header-menu-mega .navbar .dropdown-menu').mouseleave(function () {
            $(this).removeClass('show');
          });

          // do something here
        }
      });

      // document ready
    });
  });
  let cartQuantity = 0;
  languageContext.cart.forEach((e) => {
    cartQuantity = cartQuantity + e.quantity;
  });

  const DropdownItem = (props) => {
    return (
      <Link to={props.link}>
        <div className='dropdown-container'>
          <div className='item-container' title={props.text}>
            <img src={props.image} alt={props.alt} />
            {props.text}
          </div>
        </div>
      </Link>
    );
  };

  console.log(cartQuantity);
  return (
    <header class='header header-position'>
      <div class='header-top'>
        <div class='container'>
          <div class='row'>
            <div class='col-lg-12 col-md-12'>
              <ul class='d-flex justify-content-end'>
                {/* <li><a class='text-white' href='#'>How to earn cashback</a></li> */}
                <li>
                  <a class='text-white' href={`${url.meribachatfrontend}/`}>
                    Home
                  </a>
                </li>
                <li>
                  <a class='text-white' href={`${url.meribachatfrontend}/install/app`}>
                    Download App
                  </a>
                </li>
                {/* <li><a class='text-white' href='#'>Support</a></li> */}
                {!loggedIn ? (
                  <>
                    <li>
                      <a class='text-white' href='/signup'>
                        Signup
                      </a>
                    </li>
                    <li>
                      <a class='text-white' href='/login'>
                        Login
                      </a>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <a class='text-white' href='/user/profile'>
                        Profile
                      </a>
                    </li>
                    <li>
                      <a class='text-white' href='/logout'>
                        Logout
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class='header-menu header-menu-mega'>
        <nav class='navbar navbar-expand-lg navbar-dark bg-dark'>
          <div class='container'>
            <a class='navbar-brand' href='/'>
              <img src={Logo} alt='logo' />
            </a>

            <div class='d-flex align-items-center shopping-cart-search-tablet'>
              <SearchBox />
              <ul class='shopping-cart'>
                <li>
                  <a href='/cart' className='text-white h4 shopping-cart-link'>
                    <i class='fa fa-shopping-cart' />
                    {cartQuantity !== 0 ? (
                      <span className='nav-cart-number'>{cartQuantity}</span>
                    ) : (
                      <></>
                    )}
                  </a>
                </li>
              </ul>
            </div>
            <button
              class='navbar-toggler'
              type='button'
              data-toggle='collapse'
              data-target='#navbarsExample05'
              aria-controls='navbarsExample05'
              aria-expanded='false'
              aria-label='Toggle navigation'>
              <span class='navbar-toggler-icon' />
            </button>
            <div class='d-flex align-items-center shopping-cart-search-mobile'>
              <SearchBox />
              <ul class='shopping-cart'>
                <li>
                  <a href='/cart' className='text-white h4 shopping-cart-link'>
                    <i class='fa fa-shopping-cart' />
                    {cartQuantity !== 0 ? (
                      <span className='nav-cart-number'>{cartQuantity}</span>
                    ) : (
                      <></>
                    )}
                  </a>
                </li>
              </ul>
            </div>

            <div class='collapse navbar-collapse' id='navbarsExample05'>
              <ul class='navbar-nav m-auto'>
                {/* <!-- <li class="nav-item"> */}
                {/* <a class="nav-link" href="#">Gift Cards</a> */}
                {/* </li> --> */}

                <li class='nav-item dropdown'>
                  <a
                    class='nav-link dropdown-toggle'
                    href='/giftcards'
                    id='navbarDropdownGiftCard'
                    role='button'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'>
                    Gift Cards
                  </a>
                  <div
                    id='dropDownGiftCard'
                    class='dropdown-menu menu-mega-dropdown'
                    aria-labelledby='navbarDropdown'>
                    <div class='container menu-mega-bg'>
                      <div class='row'>
                        <div class='col-md-6 lbrd'>
                          <h6 class=''>Shop By Brand </h6>
                          <div class='row'>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/flipkart'>
                                    {' '}
                                    Flipkart{' '}
                                  </a>
                                </li>
                                {/* <li class='nav-item'>
                                  <a class='nav-link' href='/brand/amazon'> Amazon </a>
                                </li> */}
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/tata-cliq'>
                                    {' '}
                                    TataCliq{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/nykaa'>
                                    {' '}
                                    Nykaa{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/uber'>
                                    {' '}
                                    Uber{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/grofers'>
                                    {' '}
                                    Grofers{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/yatra'>
                                    {' '}
                                    Yatra{' '}
                                  </a>
                                </li>
                                {/* <li class='nav-item'>
                                  <a class='nav-link' href='/brand/big'> Bigbasket </a>
                                </li> */}
                                <li class='nav-item'>
                                  <a class='nav-link' href='/brand/vero-moda'>
                                    Vero Moda{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/giftcards'>
                                    {' '}
                                    View All{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <!-- /.col-md-6  --> */}
                        <div class='col-md-6 lbrd'>
                          <h6 class=''>Shop By Category </h6>
                          <div class='row'>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/accessories'>
                                    {' '}
                                    Accesories{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/apparel'>
                                    {' '}
                                    Apparels{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/grocery'>
                                    {' '}
                                    Grocery{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/e-comm'>
                                    {' '}
                                    E-Commerce{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/beauty'>
                                    {' '}
                                    Beauty{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/food'>
                                    {' '}
                                    Food{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/travel'>
                                    {' '}
                                    Travel{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/medicine'>
                                    {' '}
                                    Medicine{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/category/electronics'>
                                    {' '}
                                    Electronic{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/giftcards'>
                                    {' '}
                                    View All{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <!-- /.col-md-6  --> */}
                      </div>
                    </div>
                    {/* <!--  /.container  --> */}
                  </div>
                </li>

                <li class='nav-item dropdown'>
                  <a
                    class='nav-link dropdown-toggle'
                    href='#'
                    id='navbarDropdownCashBack'
                    role='button'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'>
                    Earn Cashback
                  </a>
                  <div
                    id='dropDownCashback'
                    class='dropdown-menu menu-mega-dropdown'
                    aria-labelledby='navbarDropdown'>
                    <div class='container menu-mega-bg'>
                      <div class='row'>
                        <div class='col-md-6 lbrd'>
                          <h6 class=''>Cashback By Brand </h6>
                          <div class='row'>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/brand/flipkart'>
                                    {' '}
                                    Flipkart{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/brand/myntra'>
                                    {' '}
                                    Myntra{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/brand/tatacliq'>
                                    {' '}
                                    TataCliq{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/brand/jockey'>
                                    {' '}
                                    Jockey{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/brand/ajio'>
                                    {' '}
                                    Ajio{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                {/* <li class='nav-item'>
                                  <a class='nav-link' href='#'> Grofers </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='#'> Yatra </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='#'> Bigbasket </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='#'> Vero Moda </a>
                                </li> */}
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback'>
                                    {' '}
                                    View All{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <!-- /.col-md-6  --> */}
                        <div class='col-md-6 lbrd'>
                          <h6 class=''>Shop By Category </h6>
                          <div class='row'>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/accessories'>
                                    {' '}
                                    Accesories{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/apparel'>
                                    {' '}
                                    Apparels{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/grocery'>
                                    {' '}
                                    Grocery{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/e-comm'>
                                    {' '}
                                    E-Commerce{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/beauty'>
                                    {' '}
                                    Beauty{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class='col-md-6'>
                              <ul class='nav flex-column'>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/food'>
                                    {' '}
                                    Food{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/travel'>
                                    {' '}
                                    Travel{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/medicine'>
                                    {' '}
                                    Medicine{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback/category/electronics'>
                                    {' '}
                                    Electronic{' '}
                                  </a>
                                </li>
                                <li class='nav-item'>
                                  <a class='nav-link' href='/cashback'>
                                    {' '}
                                    View All{' '}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        {/* <!-- /.col-md-6  --> */}
                      </div>
                    </div>
                    {/* <!--  /.container  --> */}
                  </div>
                </li>
                <li class='nav-item dropdown'>
                  <a
                    class='nav-link dropdown-toggle'
                    href='/giftcards'
                    id='navbarDropdownGiftCard'
                    role='button'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'>
                    Compare Products
                  </a>
                  <div
                    id='dropDownGiftCard'
                    class='dropdown-menu menu-mega-dropdown'
                    aria-labelledby='navbarDropdown'>
                    <div class='container menu-mega-bg'>
                      <div class='row'>
                        <div class='col'>
                          <h6 class=''>Select Product Category</h6>
                          <div class='row' style={{ marginLeft: '0px' }}>
                            <DropdownItem
                              image={Phone}
                              text='Phone'
                              alt='Compare-Phones'
                              link='/PHONE'
                            />
                            <DropdownItem
                              image={Laptop}
                              text='Laptop'
                              alt='Compare-Laptops'
                              link='/LAPTOP'
                            />
                            <DropdownItem
                              image={Television}
                              text='TV'
                              alt='Compare-TVs'
                              link='/TV'
                            />
                            <DropdownItem image={AC} text='AC' alt='Compare-ACs' link='/AC' />
                            <DropdownItem
                              image={WashingMachine}
                              text='Washing Machine'
                              alt='Compare-Washing-Machine'
                              link='/WASHING'
                            />
                            <DropdownItem
                              image={Refrigerator}
                              text='Refrigerator'
                              alt='Compare-Refrigerator'
                              link='/REFRIGERATOR'
                            />
                            <DropdownItem
                              image={Tablet}
                              text='Tablet'
                              alt='Compare-Tablet'
                              link='/TABLET'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!--  /.container  --> */}
                  </div>
                </li>
              </ul>
              <div class='d-flex align-items-center shopping-cart-search-desktop'>
                <SearchBox />
                <ul class='shopping-cart'>
                  <li>
                    <a href='/cart' className='text-white h4 shopping-cart-link'>
                      <i class='fa fa-shopping-cart' />
                      {cartQuantity !== 0 ? (
                        <span className='nav-cart-number'>{cartQuantity}</span>
                      ) : (
                        <></>
                      )}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar2;
